
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { SkeletonLoader, FilterSelect, Link } from '@warrenbrasil/nebraska-web';
import { StatementModal } from '../StatementModal';
import {
  TransactionFilters,
  TransactionFiltersOptions,
  FilterSelectOption
} from '../../types';
import { parseFilterOptions } from '../../helpers';
import {
  trackFilterClick,
  trackCleanFilterClick,
  trackWealthFilterClick
} from './track-events';
import { FilterLabel } from './types';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

const defaultPortfolioOption: FilterSelectOption = {
  label: 'Todas Carteiras',
  value: 'ALL_PORTFOLIOS'
};

@Component({
  components: {
    SkeletonLoader,
    FilterSelect,
    Link,
    StatementModal
  }
})
export default class TransactionsFilters extends Vue {
  @Prop({ type: Object, required: true })
  readonly selectedFilters!: TransactionFilters;

  @Prop({ type: Boolean, required: false, default: false })
  readonly isLoading!: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  readonly isFetchingDownload!: boolean;

  @Prop({ type: Object, required: false, default: () => ({}) })
  readonly filterOptions!: TransactionFiltersOptions;

  FilterLabel = FilterLabel;

  @Emit('change-filter')
  changeFilter(_filter: TransactionFilters) {}

  @Emit('statement-downlaod')
  submit(filters: TransactionFilters) {
    return filters;
  }

  filters: TransactionFilters = {};

  created() {
    this.filters = { ...this.selectedFilters };
  }

  get shouldShowPortfolioFilter() {
    return this.filterOptions.portfolios.length > 0;
  }

  get shouldShowExportFilter() {
    return (
      this.filterOptions.portfolios.length === 0 &&
      this.hasTransactionsReportFlag
    );
  }

  get portfolioFilterOptions(): FilterSelectOption[] {
    const parsedPortfolios = parseFilterOptions(this.filterOptions.portfolios);

    return [...parsedPortfolios, defaultPortfolioOption];
  }

  get dateFilterOptions() {
    return parseFilterOptions(this.filterOptions.datePeriods);
  }

  get movementTypeFilterOptions() {
    return parseFilterOptions(this.filterOptions.movementTypes);
  }

  private get hasTransactionsReportFlag() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.CASH_TRANSACTIONS_REPORT);
  }

  onChange(filterLabel: FilterLabel, value: string) {
    const { portfolioId, ...otherFilters } = this.filters;
    this.changeFilter({
      ...otherFilters,
      portfolioId:
        portfolioId === defaultPortfolioOption.value ? '' : portfolioId
    });
    filterLabel === FilterLabel.PortfolioId
      ? trackWealthFilterClick()
      : trackFilterClick(filterLabel, value);
  }

  clearFilters() {
    this.filters = {
      portfolioId: '',
      datePeriod: '',
      movementType: ''
    };
    this.exportValue = '';
    this.changeFilter(this.filters);
    trackCleanFilterClick();
  }

  exportValue = '';
  exportOptions = [
    {
      label: 'Arquivo PDF',
      value: 'pdf'
    }
  ];

  isModalOpen = false;

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
    this.exportValue = '';
  }

  get hasAppliedFilters() {
    return Object.values(this.filters).some(value => !!value);
  }
}
